import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=2098abf2&scoped=true"
import script from "./Deliveries.vue?vue&type=script&setup=true&lang=ts"
export * from "./Deliveries.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Deliveries.vue?vue&type=style&index=0&id=2098abf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098abf2",
  null
  
)

export default component.exports